
import React from "react";
import { useTournament } from "@/hooks/use-tournament";
import { TournamentLeaderboard } from '../shared/TournamentLeaderboard';

export const Leaderboard: React.FC = () => {
  const { tournamentState, startTournament, finishTournament } = useTournament();
  
  // Convert Mexicano players to the format expected by shared component
  const players = tournamentState.players.map(player => ({
    id: player.id,
    name: player.name,
    points: player.points,
    gamesPlayed: player.matchesPlayed,
    matchesPlayed: player.matchesPlayed,
    roundScores: player.roundScores || [],
    joinedAt: player.joinedAt
  }));

  // Debug: Check if joinedAt data is present
  React.useEffect(() => {
    console.log('🎯 Mexicano Leaderboard players:', players.map(p => ({
      name: p.name,
      joinedAt: p.joinedAt
    })));
  }, [players]);

  const handleRestartTournament = () => {
    // Get the current players and restart with them
    const playersToRestart = tournamentState.players.map(p => ({
      id: p.id,
      name: p.name,
      points: 0,
      matchesPlayed: 0
    }));
    
    // Restart the tournament with the same players
    startTournament(playersToRestart, 0, 'mexicano');
  };

  const handleFinishTournament = () => {
    if (finishTournament) {
      finishTournament();
    }
  };
  
  return (
    <TournamentLeaderboard
      players={players}
      currentRound={tournamentState.currentRound}
      isFinished={tournamentState.isFinished}
      tournamentType="mexicano"
      onRestartTournament={handleRestartTournament}
      onFinishTournament={!tournamentState.isFinished ? handleFinishTournament : undefined}
    />
  );
};
